<div class="page">
  <div class="section-body mt-3">
    <div class="row">
      <div class="col-lg-4 col-md-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">{{ project?.contractNo }}</h3>
          </div>
          <div class="card-body" id="collapseBasic">
            <span class="tag tag-blue mb-3">{{ project?.client }}</span>
            <p>Form of contract - {{ project?.formOfContract }}</p>
            <div class="row">
              <div class="col-5 py-1"><strong>Start Date:</strong></div>
              <div class="col-7 py-1">{{ project?.startDate }}</div>
              <div class="col-5 py-1"><strong>Completion Date:</strong></div>
              <div class="col-7 py-1">{{ project?.completionDate }}</div>
              <div class="col-5 py-1"><strong>Duration:</strong></div>
              <div class="col-7 py-1">
                <strong>{{ project?.duration }}</strong>
              </div>
              <div class="col-5 py-1"><strong>Maintenance Period</strong></div>
              <div class="col-7 py-1">
                <strong>{{ project?.maintenancePeriod }}</strong>
              </div>
            </div>
            <div class="card-footer">
              <div class="clearfix">
                <div class="float-left"><strong>15%</strong></div>
                <div class="float-right">
                  <small class="text-muted">Progress</small>
                </div>
              </div>
              <div class="progress progress-xs">
                <div
                  class="progress-bar bg-red"
                  role="progressbar"
                  style="width: 15%"
                  aria-valuenow="36"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div>
            <div class="mainnavigation">
              <div class="card-footer">
                <a href="#" class="btn btn-block btn-success btn-sm"
                  >View Report</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">TEST/111-P</h3>
          </div>
          <div class="card-body" id="collapseBasic">
            <span class="tag tag-blue mb-3">PR Investements</span>
            <p>Form of contract - Construction and Maintenance</p>
            <div class="row">
              <div class="col-5 py-1"><strong>Start Date:</strong></div>
              <div class="col-7 py-1">2019-12-07 11:32AM</div>
              <div class="col-5 py-1"><strong>Deadline:</strong></div>
              <div class="col-7 py-1">2021-12-06</div>
              <div class="col-5 py-1"><strong>Duration:</strong></div>
              <div class="col-7 py-1"><strong>723</strong></div>
              <div class="col-5 py-1"><strong>Issues:</strong></div>
              <div class="col-7 py-1"><strong>5</strong></div>
            </div>
            <div class="card-footer">
              <div class="clearfix">
                <div class="float-left"><strong>95%</strong></div>
                <div class="float-right">
                  <small class="text-muted">Progress</small>
                </div>
              </div>
              <div class="progress progress-xs">
                <div
                  class="progress-bar bg-red"
                  role="progressbar"
                  style="width: 95%"
                  aria-valuenow="36"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div>
            <div class="mainnavigation">
              <div class="card-footer">
                <a href="#" class="btn btn-block btn-success btn-sm"
                  >View Report</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">TEST/102-P</h3>
          </div>
          <div class="card-body" id="collapseBasic">
            <span class="tag tag-blue mb-3">Hello Investements</span>
            <p>Form of contract - Construction and Maintenance</p>
            <div class="row">
              <div class="col-5 py-1"><strong>Start Date:</strong></div>
              <div class="col-7 py-1">2019-12-07 11:32AM</div>
              <div class="col-5 py-1"><strong>Deadline:</strong></div>
              <div class="col-7 py-1">2021-12-06</div>
              <div class="col-5 py-1"><strong>Duration:</strong></div>
              <div class="col-7 py-1"><strong>723</strong></div>
              <div class="col-5 py-1"><strong>Issues:</strong></div>
              <div class="col-7 py-1"><strong>5</strong></div>
            </div>
            <div class="card-footer">
              <div class="clearfix">
                <div class="float-left"><strong>36%</strong></div>
                <div class="float-right">
                  <small class="text-muted">Progress</small>
                </div>
              </div>
              <div class="progress progress-xs">
                <div
                  class="progress-bar bg-red"
                  role="progressbar"
                  style="width: 36%"
                  aria-valuenow="36"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div>
            <div class="mainnavigation">
              <div class="card-footer">
                <a href="#" class="btn btn-block btn-success btn-sm"
                  >View Report</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="card m-3 p-3">
  <div class="card-header">
    {{ project?.contractNo }}
  </div>
  <div class="card-body">
    <h5 class="card-title">{{ project?.contractTitle }}</h5>
    <p class="card-text">
      {{ project?.startDate }} - {{ project?.completionDate }}
    </p>
    <a href="#" class="btn btn-primary mr-3" [routerLink]="viewRoute">View</a>
  </div>
</div>
 -->
